<template>
    <tailwind-layout title="Applicants">
        <template #header>
            <h2>Applicants</h2>
        </template>

        <div class="bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg p-6">
            <div class="relative">
                <div class="mb-6 flex justify-items-stretch">
                    <div class="w-4/12 sm:w-1/12 pr-4">
                        <select v-model="form.paginate" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 sm:text-sm rounded-md">
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="w-8/12 sm:w-9/12 sm:pr-4">
                        <input id="search" v-model="form.search" type="text" placeholder="Search for Applications..." class="mt-1 shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-300 rounded-md">
                    </div>
                </div>
            </div>
            <div class="rounded-md shadow overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="shadow overflow-hidden">
                                <input ref="sort_by" type="hidden" v-model="form.sort_by" />
                                <input ref="sort_direction" type="hidden" v-model="form.sort_direction" />
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <span @click="sortTable('name')">
                                            Name
                                                <icon v-show="form.sort_by === 'name'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'name'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <span @click="sortTable('email')">
                                                Email
                                                <icon v-show="form.sort_by === 'email'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'email'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Cell Phone
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Applications
                                        </th>
                                        <th scope="col" class="relative px-6 py-3">
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(user, index) in users.data" :key="index" :class="index % 2 === 0 ? 'bg-gray-50 hover:bg-gray-100' : 'bg-white hover:bg-gray-100'">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-rent-risk-blue-400 hover:text-indigo-900">
                                            <inertia-link :href="route('applicants.show', user.id)">
                                                {{ user.name }}
                                            </inertia-link>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            <a :href="'mailto:'+user.email">
                                                {{ user.email }}
                                            </a>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ user.cell_phone }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ user.applications }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <inertia-link :href="route('applications.edit', user.id)" class="text-rent-risk-blue-400 hover:text-indigo-900">Edit</inertia-link>
                                        </td>
                                    </tr>
                                    <tr v-show="!users.data.length">
                                        <td colspan="5" class="px-6 py-4 whitespace-nowrap text-sm font-medium text-center">
                                            No Applications have registered under your account yet, or none were found in the search.
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <pagination class="mt-6" :links="users.links" :results="users" :type="'users'" />
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import pickBy from 'lodash/pickBy'

export default {
    components: {
        Icon,
        Pagination,
        TailwindLayout,
    },
    props: {
        filters: Object,
        users: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                paginate: (this.filters.paginate)?this.filters.paginate:25,
                sort_by: this.filters.sort_by,
                sort_direction_icon : (this.filters.sort_direction === 'desc')?'sort-up':'sort-down'
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('users.index'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        sortTable(column) {
            this.form.sort_by = column
            this.form.sort_direction = (this.form.sort_direction === 'desc')?'asc':'desc'
            this.form.sort_direction_icon = (this.form.sort_direction === 'desc')?'sort-up':'sort-down'
       },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
